import { createSelector } from '@reduxjs/toolkit';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Routes } from '.';
import { Sidebar } from '../components/common/Sidebar';
import { useAppSelector } from '../store/store';

const AdminRoute = ({ component }) => {
	const selectAuthAndRole = createSelector(
		[state => state.auth.authenticated, state => state.auth.isAdmin],
		(isAuthenticated, isAdmin) => {
			return {
				isAuthenticated,
				isAdmin,
			};
		}
	);

	const { isAuthenticated, isAdmin } = useAppSelector(selectAuthAndRole);

	return (
		<>
			{isAuthenticated && isAdmin ? (
				<div>
					<Sidebar />
					{component}
				</div>
			) : (
				<Navigate to={Routes.Signin} />
			)}
		</>
	);
};

export default AdminRoute;
